module.exports = __webpack_public_path__ + "static/media/taro-root-curry.ae6fd93c.jpg";